import React from "react";

const ScrollToTop = (): JSX.Element => {

  const scroll = () => {
    window.scrollTo(0, 0);
  }


  return (
    <div className="footer-gototop-bar" onClick={scroll} style={{ backgroundColor: "#eeeeee" }}>
      <div className="goto-top-link">Nach oben</div>
      <div className="arrow-outside-top" id="to-top"></div>
    </div>
  );
};

export default ScrollToTop;
